import { identifyClarityUser } from "@utils/microsoftClarity";

type LoginTraits = Record<string, string | number | boolean | null | undefined>;

export const identifyClarityOnLogin = (
  userId?: string | number | null,
  traits?: LoginTraits
) => {
  const customId = userId == null ? "" : String(userId).trim();
  if (!customId || customId === "undefined" || customId === "null") return;

  const friendlyName =
    traits?.name == null ? undefined : String(traits.name).trim() || undefined;
  const stringTraits: Record<string, string | undefined> = {};

  Object.entries(traits ?? {}).forEach(([key, value]) => {
    if (key === "name" || value == null || value === "") return;
    stringTraits[key] = String(value);
  });

  identifyClarityUser({
    customId,
    friendlyName,
    traits: stringTraits,
  });
};
